'use client';

import dynamic from 'next/dynamic';

/** Below-the-fold homepage blocks. Split out so the hero can paint before this JavaScript runs. */
export const HomeLandingSections = dynamic(() => import('@/components/HomeLandingSections'));
export const HomeStoriesSection = dynamic(() => import('@/components/HomeStoriesSection'));
export const HomeCommunitySection = dynamic(() => import('@/components/HomeCommunitySection'));
export const HomeVoicesSection = dynamic(() => import('@/components/HomeVoicesSection'));
export const HomeAboutSection = dynamic(() => import('@/components/HomeAboutSection'));
export const CommunityMatrimonyServices = dynamic(() => import('@/components/CommunityMatrimonyServices'));
